import React from 'react';
import { useNavigate } from 'react-router-dom';
import CampusIdentity from '../components/campus/CampusIdentity';
import { ArrowLeft, LayoutGrid } from 'lucide-react';

const LoginPage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-white flex flex-col">
            {/* Header / Home Link */}
            <div className="max-w-7xl mx-auto w-full px-6 pt-12">
                <button 
                    onClick={() => navigate('/welcome')}
                    className="inline-flex items-center gap-2 text-slate-500 hover:text-slate-900 transition-all text-sm font-semibold group py-2"
                >
                    <ArrowLeft size={18} className="group-hover:-translate-x-1 transition-transform" />
                    Visit Home Page
                </button>
            </div>

            {/* Main Auth Component */}
            <div className="flex-1 flex flex-col items-center justify-center p-6">
                <div className="w-full max-w-5xl">
                    <CampusIdentity onVerified={() => navigate('/campus')} />
                </div>
            </div>

            {/* Simple Footer */}
            <div className="max-w-7xl mx-auto w-full px-6 py-12 text-center md:text-left">
                <p className="text-xs text-slate-400 font-medium tracking-wide">
                    COMSATS Student Network
                </p>
            </div>
        </div>
    );
};

export default LoginPage;
